import type { AbstractId } from '#shared/types/utils'
import type { FoodieId } from '#shared/types/foodies.ts'
import type { CookId } from '#shared/types/cooks.ts'

export type UserId = AbstractId<'user'>
export type UserProfileId = AbstractId<'user-profile'>

export type UserType = 'foodie' | 'cook' | 'collector'
export type RoleId = FoodieId | CookId

export enum UserTypeEnum {
  Cook = 'cook',
  Foodie = 'foodie'
}
export type RoleType = UserTypeEnum | 'both'

export type Locale = 'nl' | 'en'

export enum PressFieldEnum {
  NotAvailable = 'not-available',
  Unsuitable = 'unsuitable',
  Unknown = 'unknown',
  Suitable = 'suitable',
  Available = 'available'
}

export enum GenderEnum {
  Male = 'm',
  Female = 'f',
  PreferNotToSay = '-'
}

export type Gender = GenderEnum | string
